/*
 * ******************************************************************
 * Copyright (c) 2016-2024 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */
import { Observable, Subject } from "rxjs";
import { BaseComponent } from "@shared/components/base.component";

export abstract class ClosableDialog extends BaseComponent {

    private _closeSubject: Subject<void> = new Subject<void>();

    // Since the dialog is created dynamically, we need to notify its creator
    // when it closes, so that the creator can destroy its component.
    // This is already done inside the DialogAnchorDirective - nothing additional
    // is needed.
    public dialogClosed: Observable<void> = this._closeSubject.asObservable();

    public closable(): boolean {
        return true;
    }

    /**
     * Use to close the dialog.
     * Publishes event to notify its creator that it can destroy it.
     */
    public close(): void {
        this._closeSubject.next();
    }

    public abstract handleEsc(): void;
}
